import ListFilterType from 'www/modules/Filters/ListFilterType'

const DEFAULT_SORT = {
  value: 'any',
  name: 'По рекомендуемым',
}

const SORT_LIST = [
  DEFAULT_SORT,
  { value: 'rating', name: 'По рейтингу' },
  { value: 'name', name: 'По названию' },
]

export default class FilterTypeSort extends ListFilterType {
  constructor() {
    super()
    this.list = SORT_LIST
    this.default = DEFAULT_SORT
  }

  getDefault() {
    return this.default
  }

  static getAppliedName({ name }) {
    return name.toLowerCase()
  }
}
